<script setup lang="ts">
const { params } = useShop();
</script>

<template>
  <div class="relative flex items-center gap-2">
    <div class="relative flex-1">
      <input
        v-model="params.search"
        type="search"
        placeholder="Recherche par mots-clés..."
        class="w-full rounded border border-gray-300 py-2 pl-4 pr-10 text-sm focus:border-primary focus:outline-none"
      >
    </div>
  </div>
</template>
